import { render, staticRenderFns } from "./AnswerDeleteModal.vue?vue&type=template&id=677a315e&"
import script from "./AnswerDeleteModal.vue?vue&type=script&lang=js&"
export * from "./AnswerDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports